import { z } from 'zod'
import { MailingAddressSchema } from '@/pages/providers/components/SchoolForm/schemas/different-mailing-address.schema.ts'
import { TuitionSchema } from '@/pages/providers/components/SchoolForm/schemas/tuition.shema.ts'
import { DemographicsSchema } from '@/pages/providers/components/SchoolForm/schemas/demographics.schema.ts'
import { BankingSchema } from '@/pages/providers/components/SchoolForm/schemas/application-banking-schema.ts'
import { StandardizedTestsSchema } from '@/pages/providers/components/SchoolForm/schemas/standardized-tests.schema.ts'
import {
  AtleastOneArraySchema,
  EmailSchema,
  RequiredStringSchema,
  USPhoneNumberSchema,
} from '@/pages/providers/components/SchoolForm/schemas/application-shared.schema.ts'

const AdditionalContactSchema = z.object({
  firstName: RequiredStringSchema,
  lastName: RequiredStringSchema,
  title: RequiredStringSchema,
  phone: USPhoneNumberSchema,
  email: EmailSchema,
  role: z.string().min(1, 'Role is required'),
})
export const SchoolFormSchema = z.object({
  MailingAddressSchema,
  TuitionSchema,
  DemographicsSchema,
  BankingSchema,
  StandardizedTestsSchema,
  schoolName: RequiredStringSchema,
  streetAddress: RequiredStringSchema,
  streetAddressLine2: z.string().optional(),
  city: RequiredStringSchema,
  state: RequiredStringSchema,
  postalZipCode: RequiredStringSchema,
  county: RequiredStringSchema,
  area: RequiredStringSchema,
  lowestGrade: RequiredStringSchema,
  highestGrade: RequiredStringSchema,
  religiousAffiliation: RequiredStringSchema,
  coedStatus: RequiredStringSchema,
  hybridStatus: RequiredStringSchema,
  areasOfSpecialization: AtleastOneArraySchema,
  learningDifferences: AtleastOneArraySchema,
  additionalPrograms: AtleastOneArraySchema,
  accreditationBodies: z.array(z.string()),
  perPupilExpenditure: RequiredStringSchema,
  factsContract: RequiredStringSchema,
  maxSchoolCapacity: RequiredStringSchema,
  currentEnrollment: RequiredStringSchema,
  percentLowIncome: RequiredStringSchema,
  additionalLowIncome: RequiredStringSchema,
  ratioFullTime: RequiredStringSchema,
  ratioFullTimePartTime: RequiredStringSchema,
  primaryContactFirstName: RequiredStringSchema,
  primaryContactLastName: RequiredStringSchema,
  primaryContactTitle: RequiredStringSchema,
  primaryContactPhone: RequiredStringSchema,
  primaryContactEmail: RequiredStringSchema,
  primaryContactRole: RequiredStringSchema,
  percentStudentsESL: RequiredStringSchema,
  percentParentsESL: RequiredStringSchema,
  isNewSchool: RequiredStringSchema,
  yearEstablished: RequiredStringSchema,
  schoolHistory: RequiredStringSchema,
  schoolWebsite: z.string().optional(),
  onlinePresence: z.string().optional(),
  missionStatement: RequiredStringSchema,
  schoolLogo: z.string().optional().nullable(),
  attestation: z
    .boolean()
    .refine(
      (val) => val === true,
      'You must attest that all information contained herein is true and correct'
    ),
  accountNumberConfirmation: z.string().optional(),
  additionalContacts: z.array(AdditionalContactSchema).optional(),
})
export type SchoolFormValues = z.infer<typeof SchoolFormSchema>
